// Shipping & returns bloğu (aycan-shipping-returns-copy.liquid) davranışı.
// İki iş yapar:
//   1. Kargo yöntemi geçişi. Economy ve express değerlerinin İKİSİ de sunucuda
//      hesaplanıp data-attribute olarak basılıyor, geçiş yalnız hangisinin
//      gösterileceğini değiştiriyor. Sunucuya gidilmez, sayfa yenilenmez.
//   2. İş günü sayısını gerçek takvim tarihine çevirir; böylece önbelleklenmiş
//      sayfada bile ziyaretçinin gerçek "bugün"ünü yansıtır. Hafta sonu atlanır,
//      resmi tatiller modellenmez, bu yüzden "tahmini".
// Ülke değişimi burada DEĞİL: o Shopify Markets formu, sayfayı yenilemek
// zorunda çünkü para birimi de değişiyor.
(function () {
  if (window.__aycanShipretInit) return;
  window.__aycanShipretInit = true;

  function addBusinessDays(from, days) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added += 1;
    }
    return d;
  }

  function fmt(date, lang) {
    var opts = { month: 'short', day: 'numeric' };
    try {
      return date.toLocaleDateString(lang, opts);
    } catch (e) {
      return date.toLocaleDateString('en', opts);
    }
  }

  function paintEta(el) {
    var min = parseInt(el.getAttribute('data-days-min'), 10);
    var max = parseInt(el.getAttribute('data-days-max'), 10);
    if (isNaN(min) || isNaN(max)) return;
    var lang = document.documentElement.lang || 'en';
    var today = new Date();
    var text = fmt(addBusinessDays(today, min), lang) + ' - ' + fmt(addBusinessDays(today, max), lang);
    el.textContent = text;
    el.setAttribute('title', text);
  }

  function paintAll(root) {
    var scope = root || document;
    var cells = scope.querySelectorAll('[data-shipret-eta][data-days-min]');
    for (var i = 0; i < cells.length; i++) paintEta(cells[i]);
  }

  // Ülke seçici: değişince localization formunu gönder.
  document.addEventListener('change', function (event) {
    var el = event.target;
    if (el && el.classList && el.classList.contains('aycan-shipret__select') && el.form) {
      el.form.submit();
    }
  });

  // Yöntem geçişi.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('.aycan-shipret__seg-opt') : null;
    if (!btn) return;
    var block = btn.closest('[data-shipret]');
    if (!block) return;

    var opts = block.querySelectorAll('.aycan-shipret__seg-opt');
    for (var i = 0; i < opts.length; i++) {
      opts[i].setAttribute('aria-selected', String(opts[i] === btn));
    }

    /* Özet satırı panelin DIŞINDA (butonun içinde) durduğu için kapsam
       [data-shipret] değil, varsa .pdp-shipline sarmalayıcısı: aksi hâlde
       yöntem değişince panel güncellenip özet eski tarihte kalıyordu. */
    var scope = block.closest ? (block.closest('.pdp-shipline') || block) : block;
    var etas = scope.querySelectorAll('[data-shipret-eta]');
    for (var e = 0; e < etas.length; e++) {
      etas[e].setAttribute('data-days-min', btn.getAttribute('data-lo') || '');
      etas[e].setAttribute('data-days-max', btn.getAttribute('data-hi') || '');
      paintEta(etas[e]);
    }

    // Ücret yalnız sunucu USD olarak bastıysa doludur; boşsa dokunma,
    // "checkout'ta hesaplanır" ifadesi yerinde kalsın.
    var rate = btn.getAttribute('data-rate');
    var rateCells = scope.querySelectorAll('[data-shipret-rate]');
    if (rate) {
      for (var c = 0; c < rateCells.length; c++) rateCells[c].textContent = rate;
    }
  });

  /* ---------- Kargo satırı: açılış/kapanış ----------
     <details> kullanılmıyor: içeriğinin yüksekliği Chrome'da animasyonlanamıyor
     (grid 0fr->1fr ve ::details-content + interpolate-size denendi, ikisi de
     0px hesaplandı). Buton + panel ile hem hareket hem erişilebilirlik
     (aria-expanded / aria-controls) korunuyor.
     Süre ve easing temanın motion sözlüğünden okunuyor, ham değer yazılmıyor. */
  function motion(name, fallback) {
    var v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    if (!v) return fallback;
    if (v.indexOf('ms') > -1) return parseFloat(v);
    if (v.indexOf('s') > -1) return parseFloat(v) * 1000;
    return parseFloat(v) || fallback;
  }
  function easing(name, fallback) {
    return getComputedStyle(document.documentElement).getPropertyValue(name).trim() || fallback;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('.pdp-shipline__btn') : null;
    if (!btn) return;
    var line = btn.closest('.pdp-shipline');
    var wrap = line && line.querySelector('.pdp-shipline__wrap');
    var panel = wrap && wrap.querySelector('.pdp-shipline__panel');
    if (!wrap || !panel) return;

    var open = !line.classList.contains('is-open');
    line.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var dur = reduce ? 1 : motion('--dur-3', 320);
    var ease = open ? easing('--ease-entrance', 'ease') : easing('--ease-exit', 'ease');

    if (line._anim) line._anim.cancel();
    var from = wrap.getBoundingClientRect().height;
    var to = 0;
    if (open) {
      wrap.style.blockSize = 'auto';
      to = wrap.getBoundingClientRect().height;
      wrap.style.blockSize = from + 'px';
    }
    if (!wrap.animate) {                    // WAAPI yoksa sessizce anında aç
      wrap.style.blockSize = open ? 'auto' : '0px';
      panel.style.opacity = open ? '1' : '0';
      return;
    }
    line._anim = wrap.animate(
      [{ blockSize: from + 'px' }, { blockSize: to + 'px' }],
      { duration: dur, easing: ease, fill: 'forwards' }
    );
    panel.animate(
      [{ opacity: open ? 0 : 1 }, { opacity: open ? 1 : 0 }],
      { duration: Math.round(dur * 0.75), delay: open ? Math.round(dur * 0.2) : 0,
        easing: easing('--ease-out', 'ease'), fill: 'forwards' }
    );
    line._anim.finished.then(function () {
      /* Açıkken sabit yükseklik bırakılmıyor: ülke/yöntem değişince panel
         kendini yeniden ölçebilsin. */
      if (open && line._anim) { line._anim.cancel(); wrap.style.blockSize = 'auto'; }
    }).catch(function () {});
  });

  paintAll();
  document.addEventListener('shopify:section:load', function (e) {
    paintAll(e.target);
  });
})();
